import { FormChip } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

export const ThemedFormPeerToPeerIndividualCampaignType = () => {
  const { t } = useTranslate();

  return <FormChip variant="outlined" label={t("donationForm", "peerToPeer.chip.FundraiserCampaign")} />;
};
